<template>
  <frequency-program
    v-if="isFrequencyProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
  />
  <interval-program
    v-else-if="isIntervalProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    :ios-audio="iosAudio"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
  />
  <task-analysis-program
    v-else-if="isTaskAnalysisProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    :cached-current-program-trial="cachedCurrentProgramTrial"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
  />
  <esdm-program
    v-else-if="isEsdmProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
  />
  <sbt-program
    v-else-if="isSbtProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
    @refresh-targets="onRefreshTargets"
  />
  <set-program
    v-else-if="isSetProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
    @change-target-status="onChangeTargetStatus"
    @refresh-targets="onRefreshTargets"
  />
  <ptp-program
    v-else-if="isPtpProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
    @change-target-status="onChangeTargetStatus"
    @refresh-targets="onRefreshTargets"
  />
  <instructions-program
    v-else-if="isInstructionsProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-type="sessionType"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
    @automation-action-completed="onAutomationActionCompleted"
  />
  <program-form
    v-else-if="isAsrProgram"
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-type="sessionType"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
    @automation-action-completed="onAutomationActionCompleted"
  />
  <generic-program
    v-else
    ref="program"
    :session-program="sessionProgram"
    :sorted-targets="sortedTargets"
    :data="data"
    :dense="dense"
    :tiny="tiny"
    :visible="visible"
    :disable="disable"
    :session-paused="sessionPaused"
    :session-duration-offset="sessionDurationOffset"
    :active-prompt-levels="activePromptLevels"
    :workflow-statuses="workflowStatuses"
    :cached-current-program-trial="cachedCurrentProgramTrial"
    @record="onRecord"
    @record-multiple-data="onRecordMultipleData"
    @record-program-data="onRecordProgramData"
  />
</template>
<script>
import ProgramForm from 'components/Programs/Form/ProgramForm';
import EsdmProgram from 'components/Programs/ProgramTypes/EsdmProgram';
import FrequencyProgram from 'components/Programs/ProgramTypes/FrequencyProgram';
import GenericProgram from 'components/Programs/ProgramTypes/GenericProgram';
import InstructionsProgram from 'components/Programs/ProgramTypes/InstructionsProgram';
import IntervalProgram from 'components/Programs/ProgramTypes/IntervalProgram';
import PtpProgram from 'components/Programs/ProgramTypes/PtpProgram';
import SbtProgram from 'components/Programs/ProgramTypes/SbtProgram';
import SetProgram from 'components/Programs/ProgramTypes/SetProgram';
import TaskAnalysisProgram from 'components/Programs/ProgramTypes/TaskAnalysisProgram';
import { chain, get } from 'lodash';
import DataCollectionProgram from 'src/mixins/DataCollectionProgram';

export default {
  name: 'ProgramDataCollection',

  components: {
    EsdmProgram,
    FrequencyProgram,
    GenericProgram,
    InstructionsProgram,
    IntervalProgram,
    ProgramForm,
    SbtProgram,
    SetProgram,
    PtpProgram,
    TaskAnalysisProgram,
  },

  mixins: [DataCollectionProgram],

  props: {
    cachedCurrentProgramTrial: {
      type: Number,
      default: 0,
    },
  },

  emits: ['change-target-status', 'refresh-targets', 'automation-action-completed'],

  computed: {
    isFrequencyProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'frequency';
    },

    isIntervalProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'interval';
    },

    isEsdmProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'esdm';
    },

    isTaskAnalysisProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'taskAnalysis';
    },

    isSbtProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'sbt';
    },

    isSetProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'set';
    },

    isPtpProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'ptp';
    },

    isInstructionsProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'instructions';
    },

    isAsrProgram() {
      return get(this.sessionProgram, ['program', 'type']) === 'asr';
    },

  },

  methods: {

    /**
     * finishSession is called when a session finishes to allow the program to clean up
     * and return any data that needs to be recorded.
     *
     * @retval {
     *  sessionData: Object Data to be saved to data object
     *  finalData: Array Trial data to save when wrapping up session
     * }
     */
    finishSession() {
      if (chain(this.$refs).get(['program', 'finishSession']).isFunction().value()) {
        return this.$refs.program.finishSession();
      }
    },

    /**
     * undoData is called when the user requests to undo the last data-point in
     * case the program needs to take any actions on undo
     */
    undoData(undoDataItem) {
      if (typeof this.$refs?.program?.undoData === 'function') {
        return this.$refs.program.undoData(undoDataItem);
      }
      return true;
    },

    onAutomationActionCompleted(automationActionResults) {
      this.$emit('automation-action-completed', automationActionResults);
    },

    onChangeTargetStatus(target, newStatus, callback = null) {
      this.$emit('change-target-status', this.sessionProgram, target, newStatus, callback);
    },

    onRefreshTargets(sessionProgram) {
      this.$emit('refresh-targets', sessionProgram);
    },

  },
};
</script>
